import { useTranslation } from 'react-i18next';
import React from 'react';
import { Button } from '../ui/button';
import usePermissions from '../../hooks/usePermissions';

/** Action button that greys itself out when the role lacks the permission.
 *  `perm` accepts one key or several (any-of). */
export const PermButton = ({ perm, children, title, ...props }) => {
  const { t } = useTranslation();
  const { can, isSuperadmin } = usePermissions();
  const keys = Array.isArray(perm) ? perm : [perm];
  const allowed = !perm || isSuperadmin || keys.some((k) => can(k));
  if (allowed) return <Button title={title} {...props}>{children}</Button>;
  return (
    <span
      className="inline-flex cursor-not-allowed"
      title={t('auto.misc2.youDonTHavePermissionFor')}
    >
      <Button {...props} disabled className="opacity-50">{children}</Button>
    </span>
  );
};

export default PermButton;
